import React from 'react';

interface IOSBackButtonProps {
  onClick: () => void;
  label: string;
}

/**
 * iOS 风格的返回按钮组件
 * 包含返回箭头图标和文本标签
 */
export const IOSBackButton: React.FC<IOSBackButtonProps> = ({ onClick, label }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center text-ios-blue dark:text-ios-dark-blue py-2 -ml-2"
    >
      <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <span className="text-ios-body font-medium truncate">{label}</span>
    </button>
  );
};
